import { CrossIcon } from "./asset/icon";
import styles from "./FileListManager.module.scss";
import InputFile from "../../atom/InputFile/InputFile";

export type FileUrl = File & { url?: string };

export interface FileListManagerProps {
  listFiles?: FileUrl[];
  setFileList?: (files: FileUrl[]) => void;
  messageEmpty?: string;
  limitFiles?: number;
  addLabel?: string;
  noAddFile?: boolean;
  label?: string;
  accept?: string;
  isError?: boolean;
}
export default function FileListManager({
  listFiles,
  setFileList,
  messageEmpty = "Aucun fichier",
  limitFiles = 1,
  addLabel = "Ajouter un fichier",
  noAddFile,
  label = "Fichiers",
  accept,
  isError,
}: FileListManagerProps) {
  const handleDeleteFile = (file: FileUrl) => {
    if (listFiles && listFiles.length > 0) {
      const newFiles = listFiles.filter((f) => f !== file);
      setFileList && setFileList(newFiles);
    }
  };
  return (
    <div className={styles["global-container"]}>
      <label className={[styles["global-container__label"],isError ? styles["global-container__label--error"] : ''].join(" ")}>{label}</label>
      <div
        className={[
          styles["file-list-container"],
          isError ? styles["file-list-container--error"] : "",
        ].join(" ")}
      >
        <div className={styles["file-container"]}>
          {listFiles && listFiles.length > 0 ? (
            listFiles?.map((file, index) => (
              <FileItem
                key={index}
                file={file}
                onFileRemove={handleDeleteFile}
              />
            ))
          ) : (
            <p className={[styles["file-list-container__empty-message"], isError ? styles['file-list-container__empty-message--error']: ''].join(" ")}>
              {messageEmpty}
            </p>
          )}
        </div>
        {!noAddFile &&
          limitFiles &&
          listFiles &&
          listFiles.length < limitFiles && (
            <div className={styles["add-file-btn-container"]}>
              <InputFile
                addFiles={setFileList}
                label={addLabel}
                accept={accept}
                isError={isError}
              />
            </div>
          )}
      </div>
    </div>
  );
}

export const FileItem = ({
  file,
  onFileClick,
  onFileRemove,
}: {
  file: FileUrl;
  onFileClick?: (file: FileUrl) => void;
  onFileRemove?: (file: FileUrl) => void;
}) => {
  const isImage = file.type?.includes("image");

  return (
    <div className={styles["container-file-item"]}>
      <div className={styles["container-file-item__delete-btn"]}>
        {onFileRemove && (
          <DeleteFileBtn file={file} onFileRemove={onFileRemove} />
        )}
      </div>
      <div className={styles["file-item"]}>
        <span onClick={() => onFileClick && onFileClick(file)}>
          {file.name}
        </span>
        {isImage && (
          <img
            className={styles["file-item__img"]}
            src={file.url || URL.createObjectURL(file)}
            alt={file.name}
          />
        )}
      </div>
    </div>
  );
};

export const DeleteFileBtn = ({
  file,
  onFileRemove,
}: {
  file: File;
  onFileRemove?: (file: FileUrl) => void;
}) => {
  return (
    <button
      className={styles["delete-btn"]}
      onClick={() => onFileRemove && onFileRemove(file)}
    >
      <CrossIcon />
    </button>
  );
};
